











import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class KvButton extends Vue {
    @Prop({ default: 'green' }) readonly color!: string
    @Prop({ default: ''}) readonly title!: string
    @Prop({ type: Boolean, default: false }) disabled!: boolean
    @Prop({ type: Boolean, default: false }) loading!: boolean
    @Prop({ type: Boolean, default: false }) xs!: boolean
    @Prop({ type: Boolean, default: false }) sm!: boolean
    @Prop({ type: Boolean, default: false }) md!: boolean
    @Prop({ type: Boolean, default: false }) round!: boolean
    @Prop({ type: Boolean, default: false }) full!: boolean
    @Prop({ type: Boolean, default: false }) textual!: boolean
    @Prop({ type: Boolean, default: false }) noMargin!: boolean
    @Prop() readonly icon!: string

    onClick($event): void {
        if (this.disabled || this.loading) {
            return
        }

        this.$emit('click', $event)
    }

    get componentClass(): string[] {
        const classes = [
            `kv-button`,
            `kv-button--${this.color}`,
        ]

        // todo: the following commented code gives error.
        // if (this.small) {
        //     classes.push('kv-button--small')
        // }

        if (this.xs) {
            classes.push('kv-button--xs')
        }

        if (this.sm) {
            classes.push('kv-button--sm')
        }

        if (this.md) {
            classes.push('kv-button--md')
        }

        if (this.round) {
            classes.push('kv-button--round')
        }

        if (this.disabled || this.loading) {
            classes.push('kv-button--disabled')
        }

        if (this.loading) {
            classes.push('kv-button--loading')
        }

        if (this.textual) {
            classes.push('kv-button--textual')
        }

        if (this.full) {
            classes.push('w-full')
        }

        if (this.noMargin) {
            classes.push('kv-button--no-margin')
        }

        return classes
    }
}
